import { useState } from 'react';
import { AlertContext } from './alertContext';
import Snackbar from '@mui/material/Snackbar';
import Alert from '@mui/material/Alert';

export const AlertProvider = ({ children }) => {
    const [alert, setAlert] = useState({ open: false, message: '', severity: 'info' });

    const showAlert = (message, severity = 'info') => {
        setAlert({ open: true, message, severity });
    };

    const hideAlert = () => {
        setAlert({ ...alert, open: false });
    };

    return (
        <AlertContext.Provider value={showAlert}>
            {children}
            <Snackbar
                open={alert.open}
                autoHideDuration={6000}
                onClose={hideAlert}
            >
                <Alert onClose={hideAlert} severity={alert.severity} sx={{ width: '100%' }}>
                    {alert.message}
                </Alert>
            </Snackbar>
        </AlertContext.Provider>
    );
};